<div class="main">
    <div class="page-container" dpadContainerBasic dpadScrollableVertical>
        <div class="hero" *ngIf="creatorTeam" dpadZone="hero" dpadSelectable (focus)="heroFocus()">
            <app-hero-banner-static-image *ngIf="creatorTeam && checkHeroImages()" [hero]="creatorTeam" [roundedBorder]="true"
                [isCreatorPage]="true">
            </app-hero-banner-static-image>
            <div *ngIf="!creatorTeam" class="hero-container"></div>
        </div>

        <div class="creator-details-container" *ngIf="creatorTeam">
            <div class="name-follow-container" dpadZone="'followButton'">
                <h2>{{ creatorTeam?.displayName }}</h2>
                <app-follow-btn #followButton [creatorTeamId]="creatorTeam.id"></app-follow-btn>
            </div>
            <div class="description-wrapper" [class.expanded]="isDescriptionExpanded" dpadZone="description">
                <p #descriptionElement class="description">
                    {{ creatorTeam?.shortDescription }}
                </p>
                <button dpadSelectable *ngIf="!isDescriptionExpanded && showReadMore" class="read-more" (click)="toggleDescription()">
                    Read More
                </button>
            </div>
        </div>

        <div class="filter-items-scroll-wrapper" dpadZone="'filterTabs'">
            <div class="filter-items-container">
                <div class="sort-tabs">
                    <div class="links-container" *ngIf="creatorTeam">
                        <button class="tab-text" dpadSelectable *ngFor="let tab of creatorTeam.tabs; let idx = index"
                            [class.dpad-start]="idx == 0" [class.active]="tab == currentTab" (click)="onTabClick(tab)">
                            {{ tab }}
                        </button>
                        <a class="number-of-videos">
                            {{ creatorTeam?.mediaCount }} videos
                        </a>
                    </div>
                    <div class="search-container" (click)="searchClick()" (keyup.enter)="searchClick()" dpadSelectable>
                        <svg class="search-icon" width="31" height="31" viewBox="0 0 31 31" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.3622 22.9066C18.6334 22.9066 22.9066 18.6334 22.9066 13.3622C22.9066 8.09093 18.6334 3.81775 13.3622 3.81775C8.09093 3.81775 3.81775 8.09093 3.81775 13.3622C3.81775 18.6334 8.09093 22.9066 13.3622 22.9066Z"
                                stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M26.7242 26.7244L20.1067 20.1069" stroke="#9CA3AF" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div style="height: 33px; width: 31px;"></div>
                    <div *ngIf="displayYearFilter" class="filter-dropdown" (clickOutside)="isDropdownOpen = false">
                        <div class="creator-dropdown-header" (click)="toggleFilterDropdown()"
                            (keyup.enter)="toggleFilterDropdown()" dpadSelectable #dropDownHeader>
                            <a>
                                YEAR:
                                <span>
                                    {{ selectedFilter === '' ? 'ALL' : selectedFilter }}
                                </span>
                            </a>
                            <svg width="15" height="9" viewBox="0 0 15 9" fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.00781 8.49609C7.72656 8.49609 7.47656 8.40234 7.28906 8.21484L1.28906 2.21484C0.882812 1.83984 0.882812 1.18359 1.28906 0.808594C1.66406 0.402344 2.32031 0.402344 2.69531 0.808594L8.00781 6.08984L13.2891 0.808594C13.6641 0.402344 14.3203 0.402344 14.6953 0.808594C15.1016 1.18359 15.1016 1.83984 14.6953 2.21484L8.69531 8.21484C8.50781 8.40234 8.25781 8.49609 8.00781 8.49609Z"
                                    fill="currentColor" />
                            </svg>
                        </div>
                        <div class="creator-dropdown-menu" *ngIf="isDropdownOpen">
                            <div class="dropdown-triangle"></div>
                            <div class="filter-option" [class.active]="selectedFilter == ''" dpadSelectable
                                (click)="selectFilter('')" (keyup.enter)="selectFilter('')">
                                <p>ALL</p>
                            </div>
                            <div *ngFor="let year of creatorTeam?.years; let idx = index" 
                                class="filter-option" [class.active]="selectedFilter == year" dpadSelectable
                                (click)="selectFilter(year)" (keyup.enter)="selectFilter(year)">
                                <p>{{ year }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!loadingTab && media" class="video-grid-wrapper" dpadZone="thumbnails">
            <div class="row ml-2 mr-2 mb-3 h-100vh overflow-hidden" [scrollTopPaddingPx]="100" #scrollContainer>
                <div class="col-12 col-sm-4 col-md-3 col-xxl-2 p-2 m-0" *ngFor='let m of media; let i = index'>
                    <app-video-thumb-v2 [media]="m" thumbnailType="thumbnail" (focused)="onThumbFocused(i)" [showBadges]="false">
                    </app-video-thumb-v2>
                </div>
            </div>
        </div>

        <div *ngIf="loadingTab" class="tab-loading">
            <app-loading-spinner [widthHeightPx]="90"></app-loading-spinner>
        </div>
    </div>
</div>